import i18n from './index.js'
export default {//西班牙语
  translateText: {
    shoppingcart: "carrito de compras",
    loginorrefisterText: "iniciar sesión/registrarse",
    logoutText: "salir de sesión",
    personcenterText: "centro personal",
    placeholderText: "por favor seleccione",
    loginText: "iniciar sesión",
    registerText: "registro",
    emailText: "correo electrónico",
    pwdText: "contraseña",
    forgetpwdText: "¿Olvidó su contraseña?",
    nameText: "nombre",
    surnameText: "apellido",
    mobileText: "teléfono",
    setPwdText: "establecer una contraseña",
    countryText: "país",
    company: "la empresa",
    birthday:"cumpleaños",
    yearText:"año",
    mouthText:"mes",
    dayText:"día",
    confirmpwdText: "confirmar contraseña ",
    agreeText1: "he leído y acepto",
    agreeText2: "condiciones de uso",
    agreeText3: "y",
    agreeText4: "declaración de privacidad",
    agreeText5: "y acepto que parte de mi información personal se procese fuera de las fronteras de acuerdo con la declaración de privacidad.",
    emailplaceholder: 'por favor, introduzca un correo electrónico ',
    subscribetitleText: 'suscríbase a nuestro boletín',
    subscribeText: 'suscripción',
    shareToText: 'compartir hasta',
    searchText: 'buscar',
    subtractmoneyText: "hasta 600 menos",
    magnanimitycouponText: "un montón de cupones para recoger ",
    drawText: "obtener ahora",
    discountText: "super muchos descuentos",
    purchaseText: "comprar ahora",
    composecouponText: "compra combinada",
    manyDiscountsText: "muchas ofertas",
    recommendtitleText: "recomendado para usted",
    hotsaleproductyitleText: "productos de venta caliente",
    guessLiketitleText: "supongo que te gusta",
    NoDataText: "no hay datos todavía",
    appraiseText: "evaluación",
    certificate: "cupón",
    collectText: "colección",
    addCartText: "añadir al carrito",
    enterkeywordsText: "introduzca las palabras clave",
    useNowText: "uso inmediato",
    vouchernoText: "número de cupón",
    placeholderyearText:"seleccionar año",
    placeholdermouthText:" seleccionar mes",
    placeholderdayText:"seleccionar día",
    // 优惠券页面
    breadcrumbItemText1: 'ultra',
    breadcrumbItemText2: 'nivel',
    breadcrumbItemText3: 'grande',
    breadcrumbItemText4: 'bendición',
    breadcrumbItemText5: 'lee',
    magnanimitydrawText: 'cupones masivos para recoger',
    availablecouponstitleText: 'cupones de productos disponibles',
    drawbtnText: 'recoger',
    universalText: 'universal para todo el campo',
    useText: 'uso',
    limitText: 'limitado',
    fullText: 'lleno',
    subtractText: 'menos',
    // 折扣
    discountitemText1: 'el descuento continúa ,',
    discountitemText2: 'juhui lianlian ',
    // 组合
    commoditydiscountitemText1: 'compra combinada ,',
    commoditydiscountitemText2: 'preferencias',
    combinedpriceText: 'precio combinado ',
    economizeText: 'guardar ',
    buynowText: "comprar ahora ",
    // 产品
    ourproductsText: 'nuestros productos ',
    productcategoryText: 'categorías de productos ',
    recommendtarText: 'recomendar',
    newText: 'nuevo producto ',
    salesvolumetarText: 'volumen de ventas ',
    pricetarText: 'precio',
    // 博客
    blogmanagementText: "blogs populares ",
    latestblogsText: "últimas entradas ",
    relatedrlogsText: "blogs relacionados ",
    priceIncreasecommentText: "presentar observaciones",
    commentsectionTtxt: "área de comentarios ",
    participatingcommentsText: "comentarios",
    // 论坛
    postingText: "publicar un post ",
    topicsText: "tema",
    replyText: "responder",
    viewText: "ver",
    lastreplyText: "última respuesta ",
    publishText: "publicar",
    placeholdertypeText: "por favor seleccione una categoría de tema ",
    placeholdertitleText: "por favor, introduzca un título ",
    placeholdercontentsText: "por favor ingrese contenido ",
    fromtopicText: "desde el tema: ",
    firstfloor: "planta baja ",
    floorText: "el edificio ",
    fromText: "desde:",
    postreplyText: "publicar una respuesta ",
    // 个人中心 - 我的订单
    myorderText: "mis pedidos",
    mycommentsText: "mis comentarios ",
    mycollectionText: "mi colección ",
    couponText: "cupón",
    shippingaddressText: "dirección de envío ",
    myPostText: "mis publicaciones ",
    personalinformationText: "información personal ",
    editText: "editar ",
    allordersText: "todos los pedidos ",
    unpaidText: "pendiente de pago ",
    shippedText: "pendiente de envío ",
    receivedText: "envío pendiente ",
    evaluatedText: "por evaluar ",
    baidText: "pago en sustitución ",
    completedText: "hecho",
    productinfText: "información del producto ",
    unitpricethText: "precio por unidad ",
    quantitythText: "cantidad",
    actualpaymentthText: "pago real ",
    transactionstatusthText: "estado de la transacción ",
    operationthText: "operación",
    ordernumberText: "número de pedido ",
    orderdetailsText: "detalles del pedido ",
    cancelorderText: "cancelar orden ",
    confirmText: "ok",
    cancelText: "cancelar",
    deleteordertitle: "¿Seguro de eliminar el pedido actual?",
    successfultradeText: "éxito comercial",
    paymentText: "hacer un pago ",
    confirmreceiptText: "confirmar la recepción ",
    nncommentText: 'no hay comentarios todavía ',
    // 个人中心 - 我的评论
    productText: "producto",
    productdetailText: "detalles de evaluación ",
    replyblogText: "responder al blog:",
    //个人中心 - 收货地址
    addseliveryaddressText: "nueva dirección de envío ",
    addaddresstitleText1: "guardado",
    addaddresstitleText2: "la dirección de la barra, y también puede guardar ",
    addaddresstitleText3: "dirección de la barra ",
    defaultText: "por defecto ",
    consigneeText: "destinatario:",
    addressText: "dirección donde se encuentra: ",
    fulladdressText: "dirección completa: ",
    setdefaultText: "establecer como predeterminado",
    mobilephoneText: "teléfono móvil:",
    viewmoreText: "ver más ",
    replypostText: "responder a la publicación: ",
    // 个人中心 - 个人信息
    nameLabel:"nombre",
    sexlabel:"género",
    modifyavatarText:"cambiar la foto de perfil",
    sexmanText:"hombre",
    sexwomanText:"mujer",
    secrecyText:"confidencial",
    replaceText:"reemplazar",
    saveText:"guardar",
    oldpasswordText:"contraseña original ",
    newpasswordText:"nueva contraseña ",
    confirmpasswordText:" confirmar contraseña ",
    opdpleasolderText:"por favor, introduzca la contraseña original",
    newpleasolderText:" por favor, introduzca una nueva contraseña ",
    unboundText:"no enlazado ",
    bindingText:"enlace",
    unbindingText:"desatar",
    // 个人中心-个人信息
    regionText:"región",
    addconsigneleasolderText:"por favor rellenar el destinatario nombre",
    countrypleasolderText:"por favor seleccione un país ",
    provinceleasolderText:" por favor seleccione la provincia ",
    citypleasolderText:" por favor seleccione la ciudad ",
    areapleasolderText:" por favor seleccione una región ",
    fulladdressTextpleasolderText:"por favor ingrese la dirección detallada",
    addconsignephoneleasolderText:"por favor rellenar el destinatario celular",
    emailpleasolderText:"por favor, introduzca una dirección de correo electrónico ",
    phoneText:'número de teléfono móvil ',
    uploadimgText:" subir imagen ",
    updateuserface:"cambiar avatar ",
    uploadimgtitle1:" admite imágenes en formato JPG, jpeg, PNG ",
    uploadimgtitle2:" tamaño recomendado: 200*200 o imagen igual escala ",
    updateemailText:" cambiar correo electrónico ",
    updatemobileText:" cambiar número de teléfono ",
    dialogemailtitle:"dirección de correo electrónico ",
    dialogmobiletitle:"número de teléfono móvil ",
    dialogheadertitle:"entrada asociada a su cuenta jinger ",
    continueText:"continuar",
    verificationinformation:" información de verificación ",
    verificationinformationTitle1:"a continuar, por favor completar este usará. Nos hemos comprometido a ",
    verificationinformationTitle2:"envíe a captcha. Por favor, introduzca a continuación",
    verificationcode:" código de verificación",
    newtitle:"nuevo",
    dialognewmobiletitle:" introduzca el nuevo número de teléfono que desea asociar. Y haga clic en confirmar reemplazo",
    confirmpbtnText:"confirmar",
    titlecpuntryselect:" seleccionar país ",
    hotcountrytitle:"países populares ",
    aboutusText:" sobre nosotros ",
    // 订单详情
    havequestionsText:" tiene preguntas ",
    preferentialText:"ofertas",
    enquiryText:"consulta",
    combinationdiscountText:" oferta combinada ",
    introduceText:"introducción",
    buyermycommentsText:"comentarios del comprador",
    starText:"estrella",
    yourmailboxText:"su correo electrónico",
    placeholderquestionText:" por favor escriba su pregunta ",
    uploadimglimtText:" por favor, cargue un archivo JPG/GIF/PNG. El tamaño de la imagen no debe superar los 2MB ",
    submitbtnText:"enviar",
    // 购物车
    selectText:"seleccionar",
    tipscartsText:"productos seleccionados (sin gastos de envío)",
    settlementText:"liquidación",
    selectallText:"seleccionar todo",
    amountText:"cantidad",
    addtofavoritesText:" añadir a favoritos ",
    havecollectedText:"en colección ",
    tipdelecteproduct:"¿Seguro de eliminar el artículo actual?",
    deleteText:"eliminar",
    tipclearcart:"¿Seguro de vaciar el carrito?",
    clearcartText:"vaciar el carrito",
    totalText:"total",
    totaltipText:"artículo (sin gastos de envío):",
  }
}




// WEBPACK FOOTER //
// ./src/assets/language/local_es.js